/* app/js/src/components/blocks/create-block-modal/create-block-modal.component.scss */
.container h2 {
  color: #2dbbfc;
  font-weight: 500;
}
.container .footer {
  text-align: right;
}
.container .btn {
  margin-left: 10px;
  background-color: transparent;
  border-color: transparent;
}
.container .btn:hover {
  transform: scale(1.1);
}
.container .btn.create {
  background-color: #2dbbfc;
  color: white;
  border-radius: 3px;
}
/*# sourceMappingURL=create-block-modal.component.css.map */
